import useLabel from 'app/hooks/useLabel'

import useStyles from './CustomTooltip.styles'

const CustomTooltip = ({
    date,
    maxTrucksPerDay,
    inboundOrdersTrucksAmount,
    outboundOrdersTrucksAmount,
    inboundOrders,
    outboundOrders,
    classNames,
}: Readonly<{
    date: string,
    maxTrucksPerDay: number,
    inboundOrdersTrucksAmount: number,
    outboundOrdersTrucksAmount: number,
    inboundOrders: number,
    outboundOrders: number,
    classNames: Record<string, string>,
}>) => {
    const {
        classes,
        cx,
    } = useStyles()

    const l = useLabel()

    return (
        <div
            className={classes.tooltipWrapper}
            data-testid="tooltip"
        >
            <div className={classes.wrapper}>
                <div className={classes.item}>
                    <div className={classes.label}>{l('DATE')}</div>
                    <div>{date}</div>
                </div>
                <div className={classes.item}>
                    <div className={classes.label}>{l('MAX_TRUCKS_PER_DAY')}</div>
                    <div>{maxTrucksPerDay}</div>
                </div>
            </div>
            <div className={classes.wrapper}>
                <div className={classes.item}>
                    <div className={classes.label}>{l('INBOUND_ORDERS')}</div>
                    <div>{inboundOrders}</div>
                </div>
                <div className={classes.item}>
                    <div className={classes.label}>{l('OUTBOUND_ORDERS')}</div>
                    <div>{outboundOrders}</div>
                </div>
            </div>
            <div className={classes.wrapper}>
                <div className={classes.item}>
                    <div className={classes.label}>{l('INBOUND_TRUCKS')}</div>
                    <div className={classes.valueWrapper}>
                        <div
                            className={cx(classes.marker, classNames.inbound)}
                        />
                        <div>{inboundOrdersTrucksAmount}</div>
                    </div>
                </div>
                <div className={classes.item}>
                    <div className={classes.label}>{l('OUTBOUND_TRUCKS')}</div>
                    <div className={classes.valueWrapper}>
                        <div
                            className={cx(classes.marker, classNames.outbound)}
                        />
                        <div>{outboundOrdersTrucksAmount}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomTooltip
